import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileIconPipe } from './file-icon.pipe';
import { FileSizePipe } from './file-size.pipe';

const pipes = [FileIconPipe, FileSizePipe];

@NgModule({
  imports: [CommonModule],
  declarations: [pipes],
  exports: [pipes]
})
export class FileCommonModule {}
